/** @format */

import { ProductSku } from '../product-sku.interface';
import { ProductStyle } from '../product-style.interface';

export interface ProductsData {
  // not present on OOS products
  skus?: ProductSku[];
  // empty object if bundle product
  style: ProductStyle;
}
